import React, { useState,useEffect } from 'react'
import Tcnavbar from '../Components/Tcnavbar'
import Tcsidebar from '../Components/Tcsidebar'
import {Link} from 'react-router-dom'

function Tcdashboard() {
    const[sidebar,setSidebarOpen]= useState(false);
    const[name,setName]= useState([localStorage.getItem('username')]);

    const togglesidebar = ()=> {
      setSidebarOpen((prevState) => !prevState);
    }

    useEffect(()=>{

      const venture = localStorage.getItem('ventureid');
      let TCcheck = venture.includes('01')
   
  if(TCcheck==true){
    document.getElementById("TC-dashboard").style.display="grid"
  }
  else{
    document.getElementById("TC-dashboard").style.display="none"
 
}

  getTcAllUsers()
  getAssignUser()
  GetTcUserRole()
 },[]);

 function closeForm()
   {
      document.getElementById("modalLogoutForm").style.display = "none";
    
    }

    function Confirm() {      
        localStorage.clear();
      }


function Cancel() {
   document.getElementById("modalRegisterForm").style.display = "none";      

      }
      function logoutform(){
        document.getElementById("modalLogoutForm").style.display = "block";
      }

      let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

      function getTcAllUsers(){
        fetch('https://localhost:44312/Api/Tc/GetTcusers', {
         
        method:'GET',
      
          headers : {
      
            "Content-type": "application/json",
      
            "Accept": "application/json",
      
            "Authorization": bearer,
      
            "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
          },
      
     //body:JSON.stringify(data)
    
    }).then(response => response.json())
    .then(data => {
    console.log("Data",data) 
      localStorage.setItem("TCUserData", JSON.stringify(data));
    });

      }

      function getAssignUser(){
        const token = JSON.parse(localStorage.getItem('usertoken'));
        fetch('https://localhost:44312/Api/Tc/GetAssignTcusers', {
          method:'GET',
          headers : {
    
            "Content-type": "application/json",
    
            "Accept": "application/json",
      
            "Authorization": "Bearer " + `${token}`,
      
            "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
          },
    
          //body:JSON.stringify(data)
    
        }).then(response => response.json())
        .then(data => {
          console.log("Data",data)
         
          localStorage.setItem("TcAssignUsers", JSON.stringify(data));
        });


      }

      function GetTcUserRole(){
        fetch('https://localhost:44312/Api/Tc/GetTcUserRole', {
          method:'GET',
          headers : {
    
            "Content-type": "application/json",
    
            "Accept": "application/json",
      
           // "Authorization": "Bearer " + `${token}`,
      
            "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
          },
    
          //body:JSON.stringify(data)
    
        })
         .then(response => response.json())
        .then(data => {
          console.log(data)   
         
          localStorage.setItem("UserRole", JSON.stringify(data));

  
        });
      }
    
  return (
    <div className='tc-container' id="TC-dashboard">
     
        <Tcnavbar sidebar={sidebar} openSidebar = {togglesidebar}/>
        <Tcsidebar sidebar={sidebar} formopen={logoutform}/>
        {/* <div className='Tc-dashboardPic'>  */}
        <div className='TC-addmain'> 
{/*          
    <div className="TC-addgrid-layout">
  <div className="TC-addmain-top">
  <div className='TC-addmain-back'>

    </div> 
    <span> Welcome To ThatsCool </span>
    </div>
    </div> */}
    <div class="rotating-text-wrapper">
  <h2> Welcome To ThatsCool</h2>
  {/* <h2>This is a text animation</h2> */}
  
</div>
    </div>

  

    <div className='Tc-dashboardPic'>
    </div>
 <div className="TCpopfade" id="modalLogoutForm" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document">
    <div className="modal-contentA">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold"> Alert</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>

   <div className="modal-body mx-3">

        <div className="md-form mb-3">
            <div className='text-center'>
         <h5>Are you sure want to&nbsp;<span style={{color:"blue"}}>Logout?</span></h5>
         <h5 style={{color:"#ff6a00"}}>{name}</h5> 
          </div>
        </div>

   </div>

      <div className="modal-footer d-flex justify-content-center">
        <Link to="/"><button className='TC-logout-button' onClick={Confirm} type='submit'>Confirm</button></Link>
        &nbsp; &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;<button className='TC-logout-button' onClick={Cancel} type='submit'>Cancel</button>
      </div>

      </form>
      
    </div>
  </div>
</div>
{/* </div> */}
       </div>
    );
}

export default Tcdashboard;